import React from "react";

export default ({ input, className, meta: { error, touched }, list }) => {
  return (
    <div>
      <select {...input} className={className}>
        <option value="" disabled="disabled">
          State
        </option>
        {list.map((item, key) => (
          <option value={item} key={key}>
            {item}
          </option>
        ))}
      </select>
      {touched && error && <div className="errorMsg">{error}</div>}
    </div>
  );
};
